import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import { trataMensagensErro } from '../../utils/requests';
import { tiposAuditoria } from '../../utils/listsSelect';

class FiltroPagamentos extends Component {
  constructor() {
    super();
    this.state = {
      competencia: null,
      cliqueiNoBotao: 0,
    };
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  preparaNovaConsulta = () => {
    this.setState({
      tipoAuditoria: null,
    });
  }

  handleChange = (changeObj, name, callback = null) => {
    this.setState({
      //      competencia: {
      [name]: changeObj.value,
      //      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    }, callback);
  }

  handleSearchButton = () => {
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );
    this.handleSearch();
  }

  handleSearch = () => {
    if (this.state.tipoAuditoria) {
      this.props.handleSearchFilter(this.state);
    } else {
      trataMensagensErro(['Escolha um tipo de auditoria antes de efetuar a pesquisa.']);
    }
  }

  montaFiltros() {
    return (
      <React.Fragment>
        <div className="row">
          <Grid cols="5 5 5 5">
            <Input
              label="Tipo de Auditoria"
              name="tipoAuditoria"
              onChange={e => this.handleChange(e, 'tipoAuditoria')}
              itemList={tiposAuditoria}
              value={this.state.tipoAuditoria}
              validationState="active"
              custom
            />
          </Grid>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroPagamentos.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  tipoConsulta: PropTypes.string,
}.isRequired;

export default FiltroPagamentos;



// WEBPACK FOOTER //
// ./src/pages/consultas/FiltroAuditoria.jsx